var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Box, createTheme, Stack, ThemeProvider } from "@mui/material";
import { useIsMobileContext } from "@nitra/nkmb-card-components/contexts";
import theme from "@nitra/nkmb-theme";
import { TabLink } from "./TabLink";
var blackTheme = createTheme(theme, {
    palette: {
        primary: {
            main: theme.palette.text.primary,
            dark: "rgba(18, 18, 18, 0.2)",
        },
        action: {
            disabledBackground: theme.palette.text.primary,
            disabled: theme.palette.background.default
        }
    },
});
var classicTheme = createTheme(theme, {
    palette: {
        action: {
            disabledBackground: theme.palette.primary.main,
            disabled: theme.palette.background.paper
        }
    },
});
/**
 * Container for tabs, that will display buttons at the top, and the content of the active tab below
 */
export function ButtonTabNavigatorButtons(props) {
    var tabs = props.tabs, blackVersion = props.blackVersion, replaceLastPath = props.replaceLastPath, replaceLastPathOneDot = props.replaceLastPathOneDot;
    var isMobile = useIsMobileContext();
    return (_jsx(Box, __assign({ sx: { display: 'flex' } }, { children: _jsx(ThemeProvider, __assign({ theme: (isMobile || blackVersion) ? blackTheme : classicTheme }, { children: _jsx(Stack, __assign({ direction: "row", spacing: 0.6, sx: {
                    boxSizing: "border-box",
                    display: "inline-flex",
                    justifyContent: "center",
                    p: "4px",
                    border: "1px solid rgba(65, 35, 130, 0.1)",
                    borderRadius: {
                        xs: "4px",
                        sm: "24px", // NKW-95 - unify the border radius to 24px
                        // sm: blackVersion ? "12px" : "24px",
                    },
                    mx: "auto",
                    alignItems: "stretch",
                    flexWrap: "nowrap",
                    maxWidth: "100%",
                } }, { children: tabs.map(function (tab) {
                    return _jsx(TabLink, { label: tab.label, path: tab.path, replaceLastPath: replaceLastPath, replaceLastPathOneDot: replaceLastPathOneDot }, tab.path);
                }) })) })) })));
}
